import { useState } from "react";
import { Helmet } from "react-helmet";
import { SubmitHandler, useForm } from "react-hook-form";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import image from "../asset/img/login-background.jpeg";
import ValidatorSpan from "../component/validatorSpan";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { doLogin } from "../service/callAPI";
import { ConfigStore } from "../service/db";

type Inputs = {
	username: string;
	password: string;
	remember: boolean;
};

export default function LoginPage() {
	const { register, handleSubmit, formState } = useForm<Inputs>();
	const { isDirty, errors } = formState;

	const [isLoading, setIsLoading] = useState(false);
	const onSubmit: SubmitHandler<Inputs> = async (data) => {
		try {
			setIsLoading(true);
			const loginResp = await doLogin(data);
			localStorage.setItem("TOKEN", loginResp.token);
			await ConfigStore.setItem("TOKEN", loginResp.token);
			toast.info("Đăng nhập thành công");
			setTimeout(() => {
				window.location.href = "/";
			}, 500);
		} catch (e: any) {
			const message = e?.response?.data || e.toString();
			toast.error(message);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<>
			<Helmet>
				<meta
					name="viewport"
					content="width=device-width, initial-scale=1, shrink-to-fit=no"
				/>
				<link
					href="vendor/fontawesome-free/css/all.min.css"
					rel="stylesheet"
					type="text/css"
				/>
				<link
					href="https://fonts.googleapis.com/css?family=Nunito:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i"
					rel="stylesheet"
				/>
				<link href="css/sb-admin-2.min.css" rel="stylesheet" />
			</Helmet>
			<div className="bg-gradient-primary" style={{ height: "100vh" }}>
				<div className="container">
					<ToastContainer />
					<div className="row justify-content-center">
						<div className="col-xl-10 col-lg-12 col-md-9">
							<div className="card o-hidden border-0 shadow-lg my-5">
								<div className="card-body p-0">
									<div className="row">
										<div
											className="col-lg-6 d-none d-lg-block"
											style={{
												backgroundImage: `url(${image})`,
												backgroundPosition: "center",
												backgroundSize: "cover"
											}}
										></div>
										<div className="col-lg-6">
											<div className="p-5">
												<div className="text-center">
													<h1 className="h4 text-gray-900 mb-4">
														Welcome Back!
													</h1>
												</div>
												<Form onSubmit={handleSubmit(onSubmit)}>
													<Form.Group>
														<Form.Label>Tên đăng nhập</Form.Label>
														<Form.Control
															placeholder="Email hoặc Số điện thoại"
															{...register("username", {
																required: "Không được để trống trường này"
															})}
														/>
														{errors.username && (
															<ValidatorSpan
																message={errors.username.message}
															/>
														)}
													</Form.Group>

													<Form.Group>
														<Form.Label>Mật khẩu</Form.Label>
														<Form.Control
															type="password"
															placeholder="***"
															{...register("password", {
																required: "Không được để trống trường này"
															})}
														/>
														{errors.password && (
															<ValidatorSpan
																message={errors.password.message}
															/>
														)}
													</Form.Group>
													<Form.Group>
														<Form.Check
															type="checkbox"
															label="Lưu phiên đăng nhập"
															{...register("remember")}
														/>
													</Form.Group>
													<Button
														variant="primary"
														type="submit"
														disabled={!isDirty}
														className="btn-block"
													>
														{isLoading ? "Đang đăng nhập..." : "Đăng nhập"}
													</Button>
												</Form>
												<hr />
												<a
													href="/login#"
													className="btn btn-google btn-user btn-block"
												>
													<i className="fab fa-google fa-fw"></i> Đăng nhập với
													Google
												</a>

												<hr />
												<div className="text-center">
													<a className="small" href="/forget">
														Quên mật khẩu?
													</a>
												</div>
												<div className="text-center">
													<a className="small" href="/register">
														Tạo tài khoản mới
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
